import type { MixpanelProfileState } from "./types";
import { setMixpanelPeopleProperties } from "./mixpanel";

/** People-profile keys allowed in Mixpanel — workflow context only, never PII. */
const PROFILE_KEY_MAP = {
  gl_program_id: "glProgramId",
  is_member_active: "isMemberActive",
  eligible_to_invite: "eligibleToInvite",
  eligible_to_gift: "eligibleToGift",
  has_spouse_benefit: "hasSpouseBenefit",
  has_active_cancer_diagnosis: "hasActiveCancerDiagnosis"
} as const satisfies Record<string, keyof MixpanelProfileState>;

export function buildMixpanelProfileProperties(
  state: MixpanelProfileState
): Record<string, boolean | string> {
  const properties: Record<string, boolean | string> = {};

  if (state.glProgramId) {
    properties.gl_program_id = state.glProgramId;
  }
  if (state.isMemberActive !== null && state.isMemberActive !== undefined) {
    properties.is_member_active = state.isMemberActive;
  }
  if (state.eligibleToInvite !== null && state.eligibleToInvite !== undefined) {
    properties.eligible_to_invite = state.eligibleToInvite;
  }
  if (state.eligibleToGift !== null && state.eligibleToGift !== undefined) {
    properties.eligible_to_gift = state.eligibleToGift;
  }
  if (state.hasSpouseBenefit !== undefined) {
    properties.has_spouse_benefit = state.hasSpouseBenefit;
  }
  if (
    state.hasActiveCancerDiagnosis !== null &&
    state.hasActiveCancerDiagnosis !== undefined
  ) {
    properties.has_active_cancer_diagnosis = state.hasActiveCancerDiagnosis;
  }

  return properties;
}

export function syncMixpanelProfile(state: MixpanelProfileState): void {
  const properties = buildMixpanelProfileProperties(state);
  if (Object.keys(properties).length > 0) {
    setMixpanelPeopleProperties(properties);
  }
}

export { PROFILE_KEY_MAP };
